import { Component, OnInit, Input, ElementRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { CrudService, MessageService } from 'elbuild-ui-lib-core';
import { Activity, ProjectEmployee, Objective, Project, ProjectService, Employee } from 'toolbandi-ui-lib';
import { Observable, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as screenfull from 'screenfull';
import { Screenfull } from 'screenfull';
@Component({
	selector: 'app-objective-resources',
	templateUrl: './activities-resources.component.html',
	styleUrls: ['./activities-resources.component.scss']
})
export class ActivitiesResourcesComponent implements OnInit {


	@Input()
	projectid: number;
	project: Project;

	@Input()
	companyid: number;

	@Output()
	goto = new EventEmitter();

	objectives: Objective[];
	loading: boolean;
	resources: Employee[];
	activities: number;

	@ViewChild('tablearea', { static: true }) tablearea: ElementRef;
	tablefull: boolean;
	constructor(private projectService: ProjectService,
		private objectiveService: CrudService<Objective>,
		private activityService: CrudService<Activity>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private projectCrudService: CrudService<Project>) { }

	ngOnInit() {

		if (this.projectid) {
			this.load();
			this.projectCrudService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}



	}

	gotoResources() {
		this.goto.emit('companyresources');
	}

	load() {

		this.loading = true;
		const requests: Observable<any>[] = [];



		requests.push(this.objectiveService.getFiltered(Objective, 'objective', 'projectid', this.projectid + ''));
		requests.push(this.projectService.getActivityEmployeeMatrix(this.projectid, this.companyid));
		requests.push(this.activityService.countFiltered(Activity, 'activity', 'projectid', this.projectid + ''));

		forkJoin(requests).subscribe(data => {
			this.objectives = data[0];
			this.resources = data[1];
			this.activities = data[2];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});


	}

	toggle(a: Activity, employee: Employee) {
		if (!(this.project.isDraft || this.project.isPresented) || this.project.reporting) {
			return;
		}
		// a['r' + r.id] = !a['r' + r.id];
		if (a && employee) {
			const activityemployee = employee.getActivityEmployee(a.id);
			if (!activityemployee) {

				this.projectService.addActivityEmployee(a.id, employee.id).subscribe(data => {

					employee.addActivity(data);
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
					this.loading = false;
				});
			} else {
				this.projectService.removeActivityEmployee(activityemployee.id).subscribe(data => {
					employee.removeActivity(a.id);
				}, ({ error }) => {
					this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
					this.loading = false;
				});
			}
		}
	}

	toggleFullscreen() {
		const s = screenfull as Screenfull;
		if (this.tablefull) {

			if (s.isFullscreen) {
				s.exit();
				this.tablefull = false;
			}
		} else {
			if (s.enabled && this.tablearea && this.tablearea.nativeElement) {
				s.toggle(this.tablearea.nativeElement);
				this.tablefull = true;
			}
		}

	}



}
